'use client';

import { useMemo } from 'react';
import useSWR from 'swr';
import { getEarnings } from '@/lib/api-client';
import { getEarningsBadgeWindow, getUpcomingEarningsDates } from '@/lib/earningsBadge';

/**
 * Shared map of symbols to their next earnings date from today through seven
 * calendar days ahead (ET). SWR-deduped so every badge consumer shares one
 * fetch while retaining the date needed by its tooltip.
 */
async function fetchEarningsSoon(): Promise<Array<[string, string]>> {
  const { from, to } = getEarningsBadgeWindow();
  const entries = await getEarnings(from, to);
  return Array.from(getUpcomingEarningsDates(entries, from, to).entries());
}

const EMPTY: ReadonlyMap<string, string> = new Map();

export function useEarningsSoonSymbols(): ReadonlyMap<string, string> {
  const { data } = useSWR('earnings/soon-symbols', fetchEarningsSoon, {
    revalidateOnFocus: false,
    dedupingInterval: 5 * 60_000,
    refreshInterval: 30 * 60_000,
  });
  return useMemo(() => (data && data.length ? new Map(data) : EMPTY), [data]);
}
